function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import LocaleKeys from '../../../../../../locales/keys';
import { validateNumbersOnly } from '../../../../../../utilities/inputs.helper';
import values from 'ramda/src/values';
import uniq from 'ramda/src/uniq';
import { getFormattedServiceAttributeValue } from '../../../../../../reducers/selectors/services.list.selectors.helper';
var TelephoneSelectionController = /*#__PURE__*/function () {
  function TelephoneSelectionController() {
    _classCallCheck(this, TelephoneSelectionController);
    Object.assign(this, {
      CoreLocaleKeys: CoreLocaleKeys,
      LocaleKeys: LocaleKeys,
      contains: '',
      previousSearch: null,
      maxLength: 4,
      minLength: 0,
      placeholder: '####',
      validateNumbersOnly: validateNumbersOnly
    });
  }
  return _createClass(TelephoneSelectionController, [{
    key: "searchTelephones",
    value: function searchTelephones(previousSearch) {
      this.telephoneSelectionForm.$submitted = true;
      if (this.telephoneSelectionForm.$valid || previousSearch) {
        this.telephoneNumberSelected = null;
        var patterns = this.previousSearch = previousSearch || this.createSearchPatterns();
        this.search()(patterns);
      }
    }
  }, {
    key: "createSearchPatterns",
    value: function createSearchPatterns() {
      var patterns = [];
      var contains = this.getContainsList(this.contains);
      values(this.region.codesNpa).forEach(function (rCode) {
        rCode.nxx.forEach(function (rCodeNxx) {
          contains.forEach(function (contain) {
            patterns.push("".concat(rCode.Id).concat(rCodeNxx).concat(contain));
          });
        });
      });
      return uniq(patterns);
    }
  }, {
    key: "getContainsList",
    value: function getContainsList(wildcard) {
      var contains = [];
      var wildcardLength = wildcard.toString().length;
      if (wildcard !== undefined && wildcard !== null) {
        if (wildcardLength === 4) {
          contains.push(wildcard);
        } else if (wildcardLength === 3) {
          contains.push("".concat(wildcard, "%"));
          contains.push("%".concat(wildcard));
        } else if (wildcardLength < 3 && wildcardLength > 0) {
          contains.push("".concat(wildcard, "%"));
          contains.push("%".concat(wildcard));
          contains.push("%".concat(wildcard, "%"));
        } else if (wildcardLength === 0) {
          contains.push('%');
        } else {
          contains.push('');
        }
      }
      return contains;
    }
  }, {
    key: "getContainsTooltip",
    value: function getContainsTooltip() {
      return this.attribute.enableWildCardSearch ? this.LocaleKeys.ATTRIBUTES.TELEPHONE_SELECTION.CONTAINS_TOOLTIP : this.LocaleKeys.ATTRIBUTES.TELEPHONE_SELECTION.CONTAINS_TOOLTIP_WS;
    }
  }, {
    key: "getFormattedNumber",
    value: function getFormattedNumber(option) {
      return getFormattedServiceAttributeValue(this.attribute.serviceAttributeId, option.SerialNumber, this.serviceAttributes, this.regularExpressions);
    }
  }, {
    key: "moreOptions",
    value: function moreOptions() {
      this.telephoneNumberSelected = null;
      this.onPhoneNumberSelection(this.telephoneNumberSelected); //Report un-selection
      this.searchTelephones(this.previousSearch);
    }
  }, {
    key: "onPhoneNumberSelection",
    value: function onPhoneNumberSelection(phone) {
      this.onPhoneSelection()(phone);
    }
  }]);
}();
export default {
  template: require('./telephone.selection.template.html'),
  controller: TelephoneSelectionController,
  controllerAs: 'TelephoneSelectionController',
  bindings: {
    attribute: '<',
    //need attribute to get the attribute type id and pull inventory options
    onPhoneSelection: '&',
    regularExpressions: '<',
    search: '&',
    serviceAttributes: '<',
    stateLocations: '<',
    telephoneList: '<'
  }
};